import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core'

@Component({
    selector: 'keycom-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent implements OnInit {
  searchInput
  hasText

  @Input() disabled: boolean
  @Input() placeholder = 'Search'

  @Output() onSearch: EventEmitter<any> = new EventEmitter()

  constructor() {}

  ngOnInit() {}

  search(text) {
    this.checkHasText(text)
    this.onSearch.emit(text)
  }

  clearText() {
    this.checkHasText('')
    this.searchInput = ''
    this.onSearch.emit('')
  }

  checkHasText(text) {
    this.hasText = text !== null && text !== ''
  }
}
